<template>
  <el-col>
    <el-card class="data" v-loading="loading_category">
      <div class="flex-center" slot="header">
        <i class="fas fa-chart-pie"></i>
        <span>CATEGORY</span>
      </div>
      <div class="flex-space-between d-lg-grid grid-order-chart">
        <div class="popularity">
          <p>POPULARITY</p>
          <div class="popularity-wrap">
            <div
              class="flex-space-between popularity-info"
              v-for="(c, index) in category"
              :key="index"
            >
              <div class="flex-center">
                <div
                  class="color-square"
                  :style="`background: ${colors[index]}`"
                ></div>
                <p class="name">{{ c.category }}</p>
              </div>
              <p class="value">{{ c.video }} ( {{ popularity(c.video) }}% )</p>
            </div>
          </div>
        </div>
        <GChart
          class="chart"
          type="PieChart"
          :data="category_chart"
          :options="PieChartSett"
          v-if="category_chart.length > 1"
        />
        <div v-else class="no-data"><span>No Data</span></div>
        <div class="legend">
          <img src="@/assets/images/legend-chart-category.svg" />
          <p>Popularity</p>
        </div>
      </div>
    </el-card>
  </el-col>
</template>

<script>
import { mapState, mapActions, mapGetters, mapMutations } from 'vuex'
import { GChart } from 'vue-google-charts'

export default {
  components: {
    GChart
  },

  data() {
    return {
      selectedCommand: 'Date range',
      colors: [
        '#FC0000',
        '#FF7F00',
        '#FEE507',
        '#09FB19',
        '#00CC0E',
        '#25A776',
        '#00D5D5',
        '#015C8F',
        '#0606F9',
        '#64289E',
        '#AD0AFC',
        '#F906E1',
        '#B6B0BF',
        '#868292',
        '#605677'
      ]
    }
  },

  computed: {
    ...mapState('artistDashboard', [
      'PieChartSett',
      'loading_category',
      'artist_track',
      'artist_label',
      'category'
    ]),
    ...mapGetters('artistDashboard', ['category_chart'])
  },

  methods: {
    ...mapActions('reportsVideos', ['readTopVideos']),
    ...mapActions('artistDashboard', ['readCategoryData']),
    ...mapMutations('artistDashboard', ['setCategoryData']),
    handleCommand(command) {
      this.selectedCommand = command
    },
    popularity(video) {
      return ((video / this.sum(this.category)) * 100).toFixed(1)
    }
  },

  watch: {
    artist_track: function(valN, valO) {
      if (valN !== null) {
        this.readCategoryData()
      }
    },
    artist_label: function(valN, valO) {
      if (valN !== null) {
        this.readCategoryData()
      }
    }
  },

  created() {
    this.readCategoryData()
  },

  destroyed() {
    this.setCategoryData(null)
  }
}
</script>
